import { getAuthTokenFromSessionStorage } from 'utils/common-services/sessionStorage.service'
import store from 'index'
import { startLoader } from 'redux-store/redux/slices/loader.slice'

export const requestHandler = (request) => {
  if (request?.handlerEnabled) {
    const authToken = getAuthTokenFromSessionStorage()
    if (authToken) {
      request.headers.Authorization = `Bearer ${authToken}`
    }
  }

  // Loader Logic to add loader
  if (request?.loader) {
    store.dispatch(startLoader(request.loader))
  }

  return request
}
